'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.ensureValidators = ensureValidators;
exports.checkValues = checkValues;
exports.checkKeys = checkKeys;

var _ramda = require('ramda');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function ensureValidators(validators, props, contextName, validatorName, propName) {
  var validatorKeys = (0, _ramda.keys)(validators);
  var propsKeys = (0, _ramda.keys)(props);

  (0, _ramda.forEach)(function (key) {
    if (!(0, _ramda.contains)(key, propsKeys)) {
      throw new Error('Key "' + key + '" defined in ' + validatorName + ' but is missing in ' + propName + ' for ' + contextName);
    }
  }, validatorKeys);

  (0, _ramda.forEach)(function (key) {
    if (!(0, _ramda.contains)(key, validatorKeys)) {
      throw new Error('Key "' + key + '" defined in ' + propName + ' but is missing in ' + validatorName + ' for ' + contextName);
    }
  }, propsKeys);
}

function checkValues(validators, props, contextName, typeName) {
  (0, _ramda.forEach)(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    var validator = validators[key];

    var error = validator(_defineProperty({}, key, value), key, contextName, typeName);

    if (error instanceof Error) {
      throw error;
    }
  }, (0, _ramda.toPairs)(props));
}

function checkKeys(validators, props, contextName, typeName) {
  var validatorKeys = (0, _ramda.keys)(validators);
  var propsKeys = (0, _ramda.keys)(props);

  (0, _ramda.forEach)(function (key) {
    if (!(0, _ramda.contains)(key, validatorKeys)) {
      throw new Error('Setting property ' + key + ' on ' + contextName + ' which is not defined in ' + typeName);
    }
  }, propsKeys);
}